import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './mainRecomendations.scss';
import { Card } from 'src/components';
import { EllipseImage, EmotesIcon, PuzzleIcon, StopIcon, ZoomIcon } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const MainRecomendations = () => {
  const { t } = useTranslation();

  const options = [
    {
      title: 'mainRecomendations:divTitle',
      subtitile: 'mainRecomendations:divSub',
      image: PuzzleIcon,
    },
    {
      title: 'mainRecomendations:monTitle',
      subtitile: 'mainRecomendations:monSub',
      image: ZoomIcon,
    },
    {
      title: 'mainRecomendations:emoteTitle',
      subtitile: 'mainRecomendations:emoteSub',
      image: EmotesIcon,
    },
    {
      title: 'mainRecomendations:stopTitle',
      subtitile: 'mainRecomendations:stopSub',
      image: StopIcon,
    },
  ];

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="main-recomendations">
      <div
        className={`main-recomendations-content ${isVisible ? 'active-animation' : ''}`}
        ref={ref}
      >
        <div className="main-recomendations-title">
          <supertitle>{t('mainRecomendations:supertitle')}</supertitle>
          <h1>
            <blue-underline>{t('mainRecomendations:hint')}</blue-underline>{' '}
            <blue-text>{t('mainRecomendations:manage')}</blue-text> {t('mainRecomendations:risk')}
          </h1>
          <text>{t('mainRecomendations:subtitle')}</text>
        </div>

        <div className="main-recomendations-section">
          {options?.map((item) => (
            <Card key={item.title} type="white">
              <div className="main-recomendations-card">
                <img src={item.image} alt={item.image} />
                <text>
                  <h3>{t(item.title)}</h3>
                  {t(item.subtitile)}
                </text>
              </div>
            </Card>
          ))}
        </div>
        <img src={EllipseImage} alt={EllipseImage} className="main-recomendations-image-1" />
        <img src={EllipseImage} alt={EllipseImage} className="main-recomendations-image-2" />
      </div>
    </div>
  );
};
